import { MutationTree } from 'vuex'
import { ExamState } from './types'
import AnswerItem from '../../../common/AnswerItem';
import { IExam, IQuestion, IAnswerItem } from '../../../types';
import { IAnswer } from '../types';
import { getGroupQuestion, checkAnsweredGroup, checkBlankGroupQuestion } from '../../../lib/group-question'


export const mutations: MutationTree<ExamState> = {
  loadData (state, payload: {exam: IExam, questions: IQuestion<IAnswerItem>[][], answers: IAnswer[]}) {
    state.questions = payload.questions.reduce((acc, val) => acc.concat(val), [])
    state.answers = payload.answers
    state.currentQuestionIndex = 0
    state.exam = payload.exam
    state.timer = state.exam["time_check"] ? Math.round(state.exam["time_left"]/1000) : -1
  },

  nextQuestion (state) {
    let currentQuestionIndex = state.currentQuestionIndex + 1
    let groupQuestion = getGroupQuestion(state.questions)
    while(true) {
      if(currentQuestionIndex == state.currentQuestionIndex){
        currentQuestionIndex = groupQuestion.length
        break;
      }
      let questions = groupQuestion[currentQuestionIndex] && groupQuestion[currentQuestionIndex]["questions"]
      if(questions && !checkBlankGroupQuestion(questions) && !checkAnsweredGroup(questions, state.answers))
        break;
      currentQuestionIndex += 1
      if(currentQuestionIndex > groupQuestion.length - 1){
        currentQuestionIndex -= (groupQuestion.length + 1)
      }
    }
    state.currentQuestionIndex = currentQuestionIndex
    history.pushState(null, null, `${location.href.split("#")[0]}#question-${currentQuestionIndex}`)
  },

  updateAnswer (state, payload: {questionId: number, answers: IAnswer[]}) {
    // Remove old answers
    state.answers = state.answers.filter(answer => answer.q_id !== payload.questionId)
    state.answers = state.answers.concat(payload.answers)
  },

  pushState (state, payload: {index: number}){
    history.pushState(null, null, `${location.href.split("#")[0]}#question-${payload.index}`)
  },

  showQuestion(state, payload: {index: number}){
    (state.timer != 0) ? (state.currentQuestionIndex = payload.index) : (state.currentQuestionIndex = state.questions.length)
  },

  setConfirmSubmit (state, payload: {confirmSubmit: boolean}){
    state.confirmSubmit = payload.confirmSubmit;
  },

  prevQuestion(state){
    if(state.currentQuestionIndex > 0 && state.timer != 0){
      state.currentQuestionIndex = state.currentQuestionIndex - 1
      history.pushState(null, null, `${location.href.split("#")[0]}#question-${state.currentQuestionIndex}`)
    }
  },

  countdown(state){
    (state.timer > 0) && (state.timer != -1) && (state.timer -= 1)
    if(state.timer == 0) {
      clearInterval(state.counter)
    }
  }
}
